import React, { useEffect, useState, useContext } from 'react';
import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { commonFilter, NoneArrow } from '../constants/StyleConstants';
import { InventoriesContext } from '../contexts/InventoriesContext';
import { Bold } from './UI/TextFormatters';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  formControl: props => ({
    minWidth: 150,
    width: props.variableWidth ? props.variableWidth : 300,
  }),
  selectWrapper: {
    marginTop: 8,
    marginBottom: 4,
  },
}));

const TreasuryGroupsSelect = ({ value, setValue, title = 'Grupo de tesorería', matchById, readOnly, variableWidth }) => {
  const [options, setOptions] = useState([]);
  const classes = useStyles({ variableWidth: variableWidth === true ? 'fit-content' : variableWidth });
  const { getTheTreasuryGroups } = useContext(InventoriesContext);

  useEffect(() => {
    getTheTreasuryGroups().then(res => setOptions(res));
  }, []);

  return (
    <div className={classes.selectWrapper}>
      <FormControl className={classes.formControl}>
        <InputLabel id="select-treasury-label">{title}</InputLabel>
        <Select
          IconComponent={readOnly ? NoneArrow : undefined}
          inputProps={{ readOnly: readOnly }}
          margin="dense"
          labelId="select-treasury-label"
          id="treasury-select"
          value={value}
          onChange={e => setValue(e.target.value)}>
          {options &&
            options.map((group, index) => (
              <MenuItem key={index} value={matchById ? group.id : group}>
                {group.id} |&nbsp; <Bold>{group.name}</Bold>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TreasuryGroupsSelect;
